import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GitCompare, X } from 'lucide-react';
import { useCompare } from '@/hooks/useCompare';
import { Button } from '@/components/ui/button';

/**
 * Floating tray showing how many properties are in the compare list.
 * Hidden on the /compare page itself.
 */
export function CompareTray() {
  const navigate = useNavigate();
  const location = useLocation();
  const { count, clear } = useCompare();

  if (count === 0) return null;
  if (location.pathname === '/compare') return null;

  return (
    <div
      className="fixed bottom-20 md:bottom-6 left-1/2 -translate-x-1/2 z-40 flex items-center gap-3 px-4 py-3 rounded-full bg-primary text-primary-foreground shadow-lg border border-primary/30"
      data-testid="compare-tray"
    >
      <GitCompare className="w-4 h-4" />
      <span className="text-sm font-medium">{count} to compare</span>
      <Button
        data-testid="compare-tray-open"
        onClick={() => navigate('/compare')}
        size="sm"
        variant="secondary"
        className="rounded-full h-8"
      >
        View
      </Button>
      <button
        data-testid="compare-tray-clear"
        onClick={clear}
        aria-label="Clear compare list"
        className="p-1 rounded-full hover:bg-white/10"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
